/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminStationUpdateInput } from "../../entities/models/AdminStationUpdateInput";
import { z } from "zod/v4";

export const modelsAdminStationUpdateInputSchema = z.object({
    "is_active": z.optional(z.boolean()),
"name": z.string()
    }) as unknown as z.ZodType<ModelsAdminStationUpdateInput>